// OpenAI functions are now handled by workers - only keep directusAPI for article data
import { directusAPI } from '../../api';
// Image generation handled by backend workers

// Prompts are now handled by the workers - this file should call the worker API instead

// Add isLocalhost helper function
const isLocalhost = () => {
  return window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
};

// Add custom logging function
const log = (...args) => {
  if (isLocalhost()) {
    console.log('[generateArticle]', ...args);
  }
};

const generateArticle = async (articleId, articleDraft, keywords, toneOfVoice, complexity, language, contentType, includeImages = false) => {
  log('[generateArticle] ARTICLE GENERATION STARTED - Now using workers API instead of direct OpenAI calls');
  log('[generateArticle] Params:', {
    articleId,
    draftBlocksCount: articleDraft?.blocks?.length || 0,
    keywordsCount: keywords?.length || 0,
    toneOfVoice,
    complexity,
    language,
    contentType,
    includeImages
  });

  try {
    // Check if article has thread_id (required for worker API)
    log('Fetching article data to check thread_id');
    const articleResponse = await directusAPI.get(`/items/articles/${articleId}`);
    const articleData = articleResponse.data.data;
    const threadId = articleData.thread_id;
    
    if (!threadId) {
      log('ERROR: No thread_id found - cannot use workers API');
      throw new Error('No thread_id found for this article. Please ensure the article draft was saved correctly.');
    }

    log('Article has thread_id, calling workers API:', { articleId, threadId });

    // Get token for authorization
    const token = localStorage.getItem('directus_token');

    // Call the workers API to generate the article
    const response = await fetch('https://api.prosecaptain.com/workers/article', {
      method: 'POST',
      headers: {
        'Authorization': token ? `Bearer ${token}` : '',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        articleId: articleId,
        threadId: threadId
      })
    });

    if (!response.ok) {
      throw new Error(`Workers API error: ${response.status} ${response.statusText}`);
    }

    const result = await response.json();
    
    if (!result.success) {
      throw new Error(result.error || 'Article generation failed via workers API');
    }

    log('✅ Article generation completed via workers API');
    log('Generated content length:', result.fullArticle?.length || 0);
    
    return result.fullArticle;
  } catch (error) {
    log('ERROR in generateArticle (workers API):', error);
    throw error;
  }
}

export default generateArticle;